import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../store/actions';
import ConfirmAction from '../components/confirmAction';
import { Dialog, CommandBar, ActionButton, IconButton, ProgressIndicator } from 'office-ui-fabric-react/';
import Chart from '../components/chart';
import ChartPanel from '../components/ChartPanel';

const SELECTED_STAT = {
  maximum: 'Maximum',
  ninetieth: '90th Percentile',
  average: 'Average',
  fiftieth: '50th Percentile',
  tenth: '10th Percentile',
  minimum: 'Minimum',
  value: 'Pick Year'
};

const findStat = (stat, pickYear) => {
  if(stat === 'value'){
    return `${SELECTED_STAT[stat]} - ${pickYear}`
  } else {
    return SELECTED_STAT[stat];
  }
};

const buildAlts = alts => {
  return Object.keys(alts).join(', ');
};

const ChartTitle = ({filters, appliedFilters, filtersFetched}) => {
  
  if(!filtersFetched){ 
    return (
      <div className='chart-title default-shadow'>
        <ProgressIndicator label='Loading...'/>
      </div>
    )
  };

  const river = filters && filters.rivers && filters.rivers.filter((each) => each.river_id === appliedFilters.river && each);
  
  const locations = filters && filters.locations && filters.locations.filter((each) => {
    if(appliedFilters && appliedFilters.locations.indexOf(each.location_id) > -1){
      return each;
    } else {
       return null
    }
  }).map(each => each.location);

  const type = filters && filters.types && filters.types.filter((each) => each.type_id === appliedFilters.type && each);

  let alternatives = filters && filters.alternatives && filters.alternatives.filter((each) => {
    if(appliedFilters && appliedFilters.alternatives && appliedFilters.alternatives.indexOf(each.alternative_id) > -1){
      return each;
    } else {
       return null
    }
  }).map(each => {
    return each.short_name
  });
  if(appliedFilters.method === 'Time Series'){
    let ready = river && river[0] && locations && locations[0] && type && type[0]; 
    return (
      <div className='chart-title default-shadow'>
        { ready && <div className='details'><span className='emphasize'>Location: </span><span>{ river[0].river } at </span> <span>{ locations.join(', ') }</span></div> }
        { ready && <div className='details'><span className='emphasize'>Measure: </span><span>{type[0].type}</span> <span>({type[0].unit})</span> </div> }
        { ready && appliedFilters.startDate && appliedFilters.endDate && <div className='details'><span className='emphasize'>Date Range: </span><span>{ appliedFilters.startDate }</span> - <span>{ appliedFilters.endDate }</span> </div> }
        { ready && Object.keys(appliedFilters.selectedAlts).length !== 0 && <div className='details'><span className='emphasize'>Alternatives: </span><span>{ buildAlts(appliedFilters.selectedAlts) }</span></div>}
      </div>
    )
  };
  if(appliedFilters.method === 'Multiple Alternative'){
    let ready = river && river[0] && locations && locations[0] && type && type[0]; 
    return (
      <div className='chart-title default-shadow'>
        { ready && <div className='details'><span className='emphasize'>Location: </span><span>{ river[0].river } at </span> <span>{ locations.join(', ') }</span></div> }
        { ready && <div className='details'><span className='emphasize'>Measure: </span><span>{type[0].type}</span> <span>({type[0].unit})</span> </div> }
        { ready && appliedFilters && appliedFilters.selectedAlts && Object.keys(appliedFilters.selectedAlts).length !== 0 && <div className='details'><span className='emphasize'>Alternatives: </span><span>{ buildAlts(appliedFilters.selectedAlts) }</span></div>}
        { ready && appliedFilters && appliedFilters.selectedStat && <div className='details'><span className='emphasize'>Viewing: </span><span>{ findStat(appliedFilters.selectedStat, appliedFilters.pickYear) }</span></div>}
      </div>
    )
  };
  if (appliedFilters.method === 'Single Alternative'){
    let ready = river && river[0] && locations && locations[0] && type && type[0] && alternatives && alternatives[0]; 
    return (
      <div className='chart-title default-shadow'>
        { ready && <div className='details'><span className='emphasize'>Location: </span><span>{ river[0].river } at </span> <span>{ locations.join(', ') }</span></div> }
        { ready && <div className='details'><span className='emphasize'>Measure: </span><span>{type[0].type}</span> <span>({type[0].unit})</span> </div> }
        { ready && <div className='details'><span className='emphasize'>Alternative: </span><span>{ alternatives.join(', ') }</span></div>}
        { ready && appliedFilters && !isNaN(appliedFilters.startDate) && <div className='details'><span className='emphasize'>Pick Year: </span><span>{ appliedFilters.startDate }</span></div>}
      </div>
    )
  };
  return <div className='chart-title default-shadow'><p>Select your chart type and filters, then click 'Apply'</p></div>
};

class Charts extends Component {
  state = {
    confirmAction: null
  };

  componentDidMount = () => {
    let { match, location } = this.props;

    let { params } = match;

    let { method, source, type, locations, river, alternatives, pickYear, axisText } = params;

    let buildFromParams = method && source && type && river && alternatives && pickYear && axisText;

    let isFavorite = true; // default
    
    if(location && location.state && location.state.buildOnMount){
      method = location.state.method;
      source = location.state.source;
      river = location.state.river;
      locations = location.state.location;
      type = location.state.type;
      isFavorite = location.state.isFavorite;
      axisText = location.state.axisText;
    };

    if(source && type && locations && river){
      source = parseInt(source, 10);
      type = parseInt(type, 10);
      locations = parseInt(locations, 10);
      river = parseInt(river, 10);

      this.props.addChart('start', 'list');

      let appliedFilters = { method, source, river, locations: [locations], type, alternatives: [] };
      
      if(!pickYear){pickYear = 2012};
      if(buildFromParams){
        appliedFilters = {
          ...appliedFilters,
          pickYear: parseInt(pickYear, 10),
          selectedStat: 'value'
        };
        this.props.toggleFavorites(0, isFavorite);
        this.props.editChartY({title: axisText}, 0);
        this.props.changeFilter({method}, 0, 'method');
        this.props.changeFilter({source}, 0, 'source');
        this.props.changeFilter({river}, 0, 'river');
        this.props.changeFilter({locations: [locations]}, 0, 'location');
        this.props.changeFilter({type}, 0, 'type');
        this.props.changeFilter({selectedStat: 'value'}, 0, '');
        this.props.changeFilter({pickYear}, 0, '');
        this.props.applyFilters(appliedFilters, 0, alternatives); // apply those filters
      } else {
        appliedFilters = {
          ...appliedFilters,
          pickYear: parseInt(pickYear, 10),
          selectedStat: 'value'
        };
        this.props.toggleFavorites(0, isFavorite);
        this.props.changeFilter({pickYear}, 0, '');
        this.props.editChartY({title: axisText}, 0);
        this.props.changeFilter({method}, 0, 'method');
        this.props.changeFilter({source}, 0, 'source');
        this.props.changeFilter({river}, 0, 'river');
        this.props.changeFilter({locations: [locations]}, 0, 'location');
        this.props.changeFilter({type}, 0, 'type');
        this.props.changeFilter({selectedStat: 'value'}, 0, '');
        this.props.applyFilters(appliedFilters, 0); // apply those filters
      };
    } else {
      if(this.props.firstVisit){
        this.props.visited(); // now we can say that we've visited the page.
        // make the first chart;
        this.props.editChartY({title: 'FLOW-OUT (cfs)'}, 0);
        this.props.changeFilter({method: 'Multiple Alternative'}, 0, 'method');
        this.props.changeFilter({source: 2}, 0, 'source');
        this.props.changeFilter({river: 1}, 0, 'river');
        this.props.changeFilter({locations: [19]}, 0, 'location');
        this.props.changeFilter({type: 4}, 0, 'type');
        this.props.changeFilter({selectedStat: 'value'}, 0, '');
        this.props.changeFilter({pickYear: 2012}, 0, '');
        this.props.applyFilters({
          method: 'Multiple Alternative',
          source: 2,
          river: 1,
          locations: [19],
          type: 4,
          selectedStat: 'value',
          pickYear: 2012,
          alternatives: []
        }, 0)
      };
    };
  };

  cancelConfirmAction = () => {
    this.setState({confirmAction: null})
  }

  confirmRemove = (plotIndex) => {
    this.setState({
      confirmAction: {
        confirm: () => {
          this.props.removeChart(plotIndex);
          this.cancelConfirmAction();
        },
        cancel: this.cancelConfirmAction
      }
    })
  };



  render() {

    let { columnWidth, errorMessage, plots, filters, filtersFetched, activeChartIndex, editChartLayout } = this.props;
    
    const widthStyle = {
      width: columnWidth,
      minWidth: columnWidth,
      maxWidth: columnWidth
    };

    return (
      <div className='multi'>
        {
          errorMessage && (
            <Dialog hidden={false} onDismiss={() => this.props.clearError()}>
              <p>{ errorMessage }</p>
            </Dialog>
          )
        }
        {
          this.state.confirmAction && (
            <ConfirmAction 
              confirm={this.state.confirmAction.confirm}
              cancel={this.state.confirmAction.cancel}
            />
          )
        }
        <CommandBar
          className='command-bar'
          items={[
            {
              key: 'add-chart',
              name: 'Add Chart',
              iconProps: {iconName: 'AddTo'},
              onClick: () => this.props.addChart('start')
            },
            {
              key: 'change-view',
              name: 'Columns',
              iconProps: {iconName: 'ColumnOptions'},
              subMenuProps: {
                items: [
                  {
                    key: '1-col',
                    name: 'One Column',
                    iconProps: {
                      iconName: 'SingleColumn'
                    },
                    onClick: () => this.props.changeColumnWidth('100%')
                  },
                  {
                    key: '2-col',
                    name: 'Two Column',
                    iconProps: {
                      iconName: 'DoubleColumn'
                    },
                    onClick: () => this.props.changeColumnWidth('50%')
                  },
                ]
              }
            },
          ]} 
        />
        <div className='plots'>
          {
            filtersFetched && plots && plots.map((plot, plotIndex) => {
              return (
                <div key={ plotIndex } className='chart-container' style={ {...widthStyle, minHeight: '650px'} }>
                  <IconButton
                    onClick={() => this.props.togglePanelDisplay(!plot.showPanel, plotIndex)}
                    iconProps={{ iconName: plot.showPanel ? 'ChevronRight' : 'ChevronLeft' }} 
                    className='show-hide-filter'
                    title="Display Panel" 
                    ariaLabel="Display Panel" />
                  <div className='wrapper'>
                    <div className='chart-area'>
                      <ChartTitle 
                        filtersFetched={ filtersFetched } 
                        appliedFilters={ plot.appliedFilters }
                        filters={ filters }
                      />
                      <Chart
                        columnWidth={ columnWidth }
                        plot={ plot }
                        editChartLayout={ editChartLayout }
                        activeChartIndex={ activeChartIndex }
                        plotIndex={ plotIndex } />
                    </div>
                    <div className='panel-area default-shadow' hidden={!plot.showPanel} style={{maxHeight: '750px'}}>
                      <ChartPanel
                        plot={ plot }
                        confirmRemove={ () => this.confirmRemove(plotIndex) }
                        activeChartIndex={ activeChartIndex }
                        plotIndex={ plotIndex } />
                    </div>
                  </div>
                </div>
              )
            })
          }
          <div className='add-chart-container' style={ {...widthStyle, minHeight: '650px'} }>
            <ActionButton
              className='add-chart default-shadow'
              onClick={() => this.props.addChart('end')}
              iconProps={{ iconName: 'AddTo' }}>Add Chart</ActionButton>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
    editChartIndex: state.multi.editChartIndex,
    applyingFilters: state.multi.applyingFilters,
    copiedFilter: state.multi.copiedFilter,
    columnWidth: state.multi.columnWidth,
    errorMessage: state.multi.errorMessage,
    filters: state.multi.filters,
    filtersFetched: state.multi.filtersFetched,
    plots: state.multi.plots,
    activeChartIndex: state.multi.activeChartIndex,
    firstVisit: state.multi.firstVisit,
  }
};

const mapDispatchToProps = dispatch => {
	return {
    togglePanelDisplay: (display, index) => dispatch(actions.togglePanelDisplay(display, index)),
    removeChart: (index) => dispatch(actions.removeChart(index)),
    addChart: (location, origin) => dispatch(actions.addChart(location, origin)),
    changeColumnWidth: (width) => dispatch(actions.changeColumnWidth(width)),
    copyFilter: (copiedFilter) => dispatch(actions.setCopyFilter(copiedFilter)),
    pasteFilter: (pasteFilter, index) => dispatch(actions.pasteFilter(pasteFilter, index)),
    changeFilter: (changes, index, item) => dispatch(actions.changeFilter(changes, index, item)),
    applyFilters: (filters, index, alternatives) => dispatch(actions.applyFilters(filters, index, alternatives)),
    clearError: () => dispatch(actions.clearError()),
    setAppliedFilters: (changes, index) => dispatch(actions.setAppliedFilters(changes, index)),
    toggleFavorites: (index, bool) => dispatch(actions.toggleFavorites(index, bool)),
    editChartY: (changes, index) => dispatch(actions.editChartY(changes, index)),
    editChartLayout: (data, index) => dispatch(actions.editChartLayout(data, index)),
    visited: () => dispatch(actions.visited())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Charts);



// WEBPACK FOOTER //
// ./src/containers/Charts.js